import { render, staticRenderFns } from "./FrontHistory.vue?vue&type=template&id=fb096866&scoped=true"
import script from "./FrontHistory.vue?vue&type=script&lang=js"
export * from "./FrontHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb096866",
  null
  
)

export default component.exports